import React,{useState, useEffect} from "react";


export default function IconSelector({value, options, onClick}) {


	var selected = [];
	
	useEffect(() => {
		selected = Array.isArray(value) ? value : (value ? Array.from(value) : []);
		setSelectedValues(selected);
	}, [value]);
	//var selected = Array.isArray(value) ? value : [value];
	const vs = Array.isArray(options) ? options : [options];
	const selectable = onClick ? 'selectable ' :  '';
	const [selectedValues,setSelectedValues]				= useState(selected);

		
	const handleClick = function(e){
		
		const elem = e.target.closest(".selectableIcon");
		const v = elem.dataset.value;
		if(!onClick)
			return;
		
		var nv = [...selectedValues];

		var index = nv.indexOf(v);
		if(index !== -1){
			nv.splice(index, 1);
		}
		else {
			nv.push(v);
		}
		onClick(nv);
		setSelectedValues(nv);
	} 
		
		
		
	return (<>
		
		{vs.map((i)=>{
			if(!i)
				return;
			return (<div key={i.value} onClick={handleClick} data-value={i.value} className={"selectableIcon " +selectable + (selectedValues.includes(i.value) ? 'active' : '')}><div className={i.className} title={i.label}>{i.icon}</div></div>)
		})}
		</>
	);
}